// Generated by uRequire v0.7.0-beta.15 target: 'dist' template: 'nodejs'
(function () {
  
var __isAMD = !!(typeof define === 'function' && define.amd),
    __isNode = (typeof exports === 'object'),
    __isWeb = !__isNode;

var Path = require('./path'),
    O = require('./ops');

module.exports = (function () {
  return function (arg) {
    var closed, head, l, path, points, ref, tail;
    points = arg.points, closed = arg.closed;
    l = points.length;
    head = points[0];
    tail = points.slice(1, +l + 1 || 9000000000);
    path = tail.reduce(function (pt, p) {
      return pt.lineto.apply(pt, p);
    }, (ref = Path()).moveto.apply(ref, head));
    return {
      path: closed ? path.closepath() : path,
      centroid: O.average(points)
    };
  };
}).call(this);


}).call(this)


/*****************
 ** WEBPACK FOOTER
 ** ./~/paths-js/polygon.js
 ** module id = 287
 ** module chunks = 0
 **/